
import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftCircleLeftFill } from "bootstrap-icons/icons/arrow-left-circle-fill.svg";
import { ReactComponent as ArrowRightCircleLeftFill } from "bootstrap-icons/icons/arrow-right-circle-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../spinner/Spinner";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { handleError } from "../../components/utils/AuthenticationCheck";
import PhysicalProCard from "./PhysicalProCard";

const PhysicalProductList = () => {
  const [products, setProducts] = useState([]);
  // const [productId, setProductId] = useState("");
  const [allProducts, setAllProducts] = useState([]); // full dataset here
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage, setProductsPerPage] = useState(12);
  const [filterText, setFilterText] = useState("");
  const [totalProducts, setTotalProducts] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchPhysicalProducts = async () => {
      setLoading(true);
      try {
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) {
          throw new Error("No access token found.");
        }

        const response = await axios.get(ApiServices.getAllPhysicalProduct, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message, data } = response.data;

        if (status === 200) {
          const excludedKeys = ["created_at", "updated_at", "id", "name"];
          const discountObject = data.discounts;
          // console.log("discount obj", discountObject);

          const productsArray = Object.entries(discountObject)
            .filter(([key]) => !excludedKeys.includes(key))
            .map(([key, value]) => ({
              id: key,
              name: key.replace(/_/g, " ").toUpperCase(),
              discount: value,
            }));


          // original products in allProducts
          // console.log("id is here", productsArray);
          setAllProducts(productsArray);
          // setProductId(productsArray.id)
          setProductsPerPage(data.per_page || 12);

          toast.success(message, { toastId: "product-fetch-success" });
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchPhysicalProducts();
  }, [navigate]);

  // Local filtering + pagination without calling API
  useEffect(() => {
    let filtered = allProducts;

    if (filterText.trim() !== "") {
      filtered = allProducts.filter(
        (item) =>
          item.name.toLowerCase().includes(filterText.toLowerCase().trim()) ||
          item.discount.toString().includes(filterText.toLowerCase().trim())
      );
    }

    // Sort alphabetically
    const sorted = filtered.sort((a, b) => a.name.localeCompare(b.name));

    // Pagination
    const indexOfLast = currentPage * productsPerPage;
    const indexOfFirst = indexOfLast - productsPerPage;
    const current = sorted.slice(indexOfFirst, indexOfLast);

    setProducts(current);
    setTotalProducts(filtered.length);
  }, [filterText, currentPage, productsPerPage, allProducts]); // run when these change

  const hasPrevPage = currentPage > 1;
  const hasNextPage = currentPage * productsPerPage < totalProducts;

  const handlePageChange = (page) => setCurrentPage(page);

  const handleSearchChange = (event) => setFilterText(event.target.value);

  useEffect(() => {
    setCurrentPage(1); // Reset to first page on search
  }, [filterText]);

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section
            className="w-full pl-[3%] pr-[3%] pt-3 my-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <nav className="bg-gray-200 py-0 px-4 rounded-lg ">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 ">
                    Bills Product Discount
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>

          <div className="pb-4 bg-white flex flex-wrap items-center justify-between gap-4">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                placeholder="Search"
                value={filterText}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <section className="text-gray-600 body-font">
              <div className="container px-1 py-2 mx-auto">
                <div className="flex flex-wrap -m-2 capitalize">
                  {products.length > 0 ? (
                    products.map((product) => (
                      <PhysicalProCard
                        key={product.id}
                        product={product}
                        setProducts={setProducts}
                        setAllProducts={setAllProducts}
                      />
                    ))
                  ) : (
                    <div className="w-full text-center">No products found</div>
                  )}
                </div>

                {/* Pagination */}
                <div className="flex justify-end mt-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination flex mx-auto">
                      <li className={`page-item ${!hasPrevPage ? "disabled" : ""}`}>
                        <button
                          className="text-dGrey3 bg-black2 hover:bg-darkGreen2 rounded-full text-sm px-5 py-2 inline-flex items-center gap-1 m-2"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={!hasPrevPage}
                        >
                          <ArrowLeftCircleLeftFill className="w-5 h-5 mr-2" />
                          Prev
                        </button>
                      </li>
                      <li className={`page-item ${!hasNextPage ? "disabled" : ""}`}>
                        <button
                          className="text-dGrey3 bg-black2 hover:bg-darkGreen2 rounded-full text-sm px-5 py-2 inline-flex items-center gap-1 m-2"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={!hasNextPage}
                        >
                          Next
                          <ArrowRightCircleLeftFill className="w-5 h-5 ml-2" />
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </section>
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default PhysicalProductList;


